import { useNavigate } from 'react-router-dom'
// import { useContextData } from '../../core/context/index'

const FooterHome = () => {
  const navigate = useNavigate()
  // const { siteSettings } = useContextData()
  const year = new Date().getFullYear()
  return (
    <section
      className='pt-3'
      style={{ backgroundColor: '#0E1116', color: '#9AA6B2' }}
    >
      <div className='container'>
        <div className='mb-3'>
          <div>
            <div className='row pb-1 mx-auto gx-2 gy-2 align-items-center'>
              <div className='col-12 col-md-4'>
                <img
                  className='img-fluid img-size'
                  src='/logo.png'
                  alt='logo'
                />
              </div>
              <div className='col-12 col-md-4 text-md-center mt-2 mt-md-0'>
                <h5 className='mb-0 pt-2 fw-bold'>
                  Your <span className='fw-bold' style={{ color: '#1dafa1' }}>Crypto</span> Gateway
                </h5>
              </div>
              <div className='col-12 col-md-4'></div>
            </div>
          </div>
        </div>
        <div>
          <div className='row mx-auto gx-2 gy-3 fontSizeFooter extraHover'>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Corporate
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/about')}
                >
                  About Us
                </li>
                <li
                  onClick={() => navigate('/my/referral')}
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                >
                  Referrals
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => window.open('./assets/Unitic_Exchange_Terms_Of_Use.pdf', '_blank')}
                >
                  Terms Of Use
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => window.open('./assets/Unitic_Exchange_Privacy_Policy.pdf', '_blank')}
                >
                  Privacy Policy
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/career')}
                >
                  Careers
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/faq')}
                >
                  FAQ
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/blogs')}
                >
                  Blogs
                </li>
                {/* <li style={{ color: '#9AA6B2', fontWeight: 700 }}>AML & CFT</li> */}
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Products
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/TRX_INR')}
                >
                  Spot Trading
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/futures/trade/XBTUSDTM')}
                >
                  Futures Trade
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/Insta-Trade')}
                >
                  Insta Trade
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() =>
                    // window.open('https://utistaking.com/', '_blank')
                    navigate('/earn')
                  }
                >
                  Earn
                </li>
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Services
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/help-center')}
                >
                  Help Center
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() =>
                    window.open(
                      'https://www.uniticexchange.com/sitemap.xml',
                      '_blank',
                    )
                  }
                >
                  Sitemap
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/help-center')}
                >
                  Technical Support
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() =>
                    navigate('/learn-crypto')
                  }
                >
                  Unitic Academy
                </li>
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Business
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/otc-desk')}
                >
                  OTC Desk
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/help-center')}
                >
                  Token Listing
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/sub-broker')}
                >
                  Sub Broker
                </li>
                {/* <li style={{ color: '#9AA6B2', fontWeight: 700 }}>
                  API Services
                </li> */}
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Developer
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/api-docs')}
                >
                  API Documentation
                </li>
                {/* <li style={{ color: '#9AA6B2', fontWeight: 700 }}>
                  Price Feeds
                </li> */}
              </ul>
            </div>
          </div>
          <div className='row mx-auto gx-2 gy-3 fontSizeFooter extraHover mt-1'>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Crypto Prices
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/BTC_INR')}
                >
                  Buy Bitcoin
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/ETH_INR')}
                >
                  Buy Ethereum
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/SOL_INR')}
                >
                  Buy Solana
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/XRP_INR')}
                >
                  Buy Ripple
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/USDT_INR')}
                >
                  Buy USDT
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/SUI_INR')}
                >
                  Buy SUI
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/TRX_INR')}
                >
                  Buy Tron
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/DOGE_INR')}
                >
                  Buy Doge
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/ADA_INR')}
                >
                  Buy Cardano
                </li>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() => navigate('/spot/LINK_INR')}
                >
                  Buy Chainlink
                </li>
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                App Download
              </p>
              <ul className='p-0'>
                <li
                  style={{ color: '#9AA6B2', fontWeight: 700 }}
                  onClick={() =>
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.app.unitic&hl=en-IN/',
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }
                >
                  Android Download
                </li>
                <li style={{ color: '#9AA6B2', fontWeight: 700 }}>
                  iOS Download
                </li>
              </ul>
            </div>
            <div className='col-6 col-sm-6 col-md-2'>
              <p
                className='font-weight-900 pb-2 text-logo-grad-home'
                style={{ color: '#fff' }}
              >
                Community
              </p>
              <div className='row iconSize' style={{ gap: '10px', paddingBottom: '24px' }}>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open('https://x.com/unitic_exchange', '_blank')
                  }
                >
                  <img src='/assets/socialLogos/x.svg' alt='x' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open('https://t.me/uniticexchange', '_blank')
                  }
                >
                  <img src='/assets/socialLogos/telegram.svg' alt='telegram' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(
                      'https://www.instagram.com/uniticexchange/',
                      '_blank',
                    )
                  }
                >
                  <img src='/assets/socialLogos/instagram.svg' alt='instagram' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(
                      'https://www.youtube.com/@UniticExchange2025',
                      '_blank',
                    )
                  }
                >
                  <img src='/assets/socialLogos/youtube.svg' alt='youtube' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open('https://discord.gg/pMEsMXMgDR', '_blank')
                  }
                >
                  <img src='/assets/socialLogos/discord.svg' alt='discord' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(
                      'https://www.linkedin.com/company/unitic-exchange/',
                      '_blank',
                    )
                  }
                >
                  <img src='/assets/socialLogos/linkedin.svg' alt='linkedin' />
                </div>
                <div
                  className='col-2'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(
                      'https://www.facebook.com/uniticexchange',
                      '_blank',
                    )
                  }
                >
                  <img src='/assets/socialLogos/facebook.svg' alt='facebook' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='fontSizeFooter pt-3'>
          <div>
            <p className='font-weight-900 pb-0 text-logo-grad-home'
              style={{ color: '#fff', fontSize: '14px' }}>
              Disclaimer
            </p>
          </div>
          <div>
            <p style={{ color: '#9AA6B2', fontWeight: 700, fontSize: '12px' }} className='footer-sm-justify'>Crypto assets and NFTs are highly volatile and speculative in nature, with prices subject to sudden and significant fluctuations due to market demand, regulatory developments, technological changes, liquidity conditions, and external global factors; investments in these digital assets carry a high level of risk, including the potential loss of your entire invested capital, and may not be suitable for all investors. Past performance is not indicative of future results, and there is no guarantee of returns or capital protection. Users are strongly advised to conduct thorough research, assess their financial situation, risk tolerance, and investment objectives before participating, and to trade cautiously by investing only funds they can afford to lose without impacting their financial stability. Unitic Exchange operates exclusively through its official domain, www.uniticexchange.com and users must always verify the website URL carefully before logging in or making any transactions, as the platform is not responsible for losses arising from accessing fraudulent or lookalike websites. Furthermore, Unitic Exchange will never contact users via phone calls, messages, or emails to request sensitive information such as passwords, OTPs, private keys, or account details, and users must not share their confidential information with anyone under any circumstances to avoid scams and unauthorized access.</p>
          </div>
        </div>
        <div>
          <hr style={{ opacity: '0.5' }} />
          <div className='row pb-3 align-items-start'>
            <div className='col'>
              {/* {siteSettings && (
                <p className='very-small-text-2 mb-0'>
                  {siteSettings.siteName}
                </p>
              )} */}
              <p className='very-small-text-2 mb-0 font-weight-900' style={{ color: '#fff' }}>
                Unitic Exchange
              </p>
            </div>
            <div className='col'>
              <p className='very-small-text-2 mb-0 text-end font-weight-900' style={{ color: '#fff' }}>
                All rights reserved {year}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterHome
